var _defs, _polygon, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndorLogoHLight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 912.37 181.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#15d5d9;}.cls-2{fill:#004e59;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "StraightBlue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "219.8 81.7 180.4 144.6 157 181.9 102.6 94.9 62.8 31.4 49.6 52.4 31.2 81.7 68 81.7 78.8 99 0 99 39.4 36.1 62.8 -1.2 117.2 85.7 157 149.3 170.2 128.3 188.6 99 151.8 99 141 81.7 219.8 81.7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M350.27,30h23.6l49.9,120.5H397l-10.7-26.8H337l-10.7,26.8h-26.1Zm27,70.4-15.5-38.8-15.5,38.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M433.47,30h23.6l54.6,74.2V30H537V150.5h-21.8l-56.4-76.6v76.6h-25.3V30Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M556.67,30h45.4c36.6,0,61.9,26,61.9,59.9v.3c0,33.9-25.3,60.3-61.9,60.3h-45.4Zm25.6,23.9v72.6h19.8c21,0,35.1-14.6,35.1-36v-.3c0-21.3-14.1-36.3-35.1-36.3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M673.27,90.6v-.3c0-33.1,26.1-60.3,62.1-60.3s61.7,26.8,61.7,59.9v.3c0,33.1-26.1,60.3-62.1,60.3S673.27,123.7,673.27,90.6Zm97,0v-.3c0-20-14.6-36.6-35.3-36.6S700,70,700,90v.3c0,20,14.6,36.6,35.3,36.6S770.27,110.6,770.27,90.6Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M811.57,30h53.3c14.8,0,26.3,4.3,34,12.2,6.5,6.7,10,16.2,10,27.5V70c0,19.5-10.2,31.7-25,37.4l28.5,43h-30l-25-38.6h-20.1v38.6h-25.6V30Zm51.6,58.5c12.5,0,19.6-6.9,19.6-17v-.3c0-11.4-7.7-17.2-20.1-17.2h-25.5V88.6h26Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndorLogoHLight);
export default __webpack_public_path__ + "static/media/andor-logo-h-light.39603b61a233cb1310707f9f60f2933e.svg";
export { ForwardRef as ReactComponent };